import DetailClient from './Detail';
export default DetailClient;